module.exports = __webpack_public_path__ + "static/gm-35-039c9c8662024eb2bf9c5f9cd9fc67dc.jpg";